/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Estimated_Cost_BadgeInputs */



/**
* | output |
* | --- |
* | "Estimated cost" |
*
* @param {Dashboard_Estimated_Cost_BadgeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const dashboard_estimated_cost_badge = /** @type {((inputs?: Dashboard_Estimated_Cost_BadgeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Estimated_Cost_BadgeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Geschätzte Kosten")
	return /** @type {LocalizedString} */ ("Estimated cost")
});